module.exports = __webpack_public_path__ + "media/Popular_Website_Moodfilm_V04_CLEAN_Small.04a189c1.mp4";